export default __webpack_public_path__ + "static/media/version-history-collapse-active.4c386fc7.svg";